// extracted by mini-css-extract-plugin
export default {"margin-top":"yVznoIeQPD4fccPNhpYU","chip-container":"aym4x6btcfIsPeKSNr4f","centered-text":"cowF_KYBwQVH03N9wPVF"};